import React, { Component } from "react";
import { Grid, Row, Col, ControlLabel, FormGroup } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { countryList } from "./countryList";
import { addCountry } from "Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables";

class AddCountry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryCode: "",
      obj: "",
      state: "",
      filterCountryList: [],
    };
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
  }

  handleOnSubmit = async () => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const findCountryName = this.state.filterCountryList.find(
      (item) => item.value === this.state.countryCode
    );
    console.log("findCountryName", findCountryName);
    const countryBody = {
      country_name: findCountryName.label,
      country_code: this.state.countryCode,
    };
    await addCountry(obj, countryBody)
      .then(() => {
        this.state._notificationSystem.addNotification({
          message: "Country Added Successfully!",
          level: "success",
        });
        setTimeout(() => {
          this.props.history.push("/admin/country");
        }, 3000);
      })
      .catch(() => {
        this.state._notificationSystem.addNotification({
          message: "Something went wrong!",
          level: "error",
        });
      });
  };

  componentDidMount() {
    const countries = JSON.parse(localStorage.getItem("existingCountries"));
    const filterCountryList = countryList.filter((item) => {
      return !countries.some((obj) => obj.country_code === item.value);
    });
    this.setState({ filterCountryList: filterCountryList });
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }
  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={6}>
              <Card
                content={
                  <div>
                    <FormGroup>
                      <>
                        <ControlLabel>Country</ControlLabel>
                        <div
                          style={{
                            display: "flex",
                            gap: 8,
                          }}>
                          <select
                            name="role"
                            className="form-control"
                            value={this.countryCode}
                            onChange={(e) => {
                              this.setState({ countryCode: e.target.value });
                            }}>
                            <React.Fragment>
                              <option value="">Select Country</option>
                              {this.state.filterCountryList.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })}
                            </React.Fragment>
                          </select>
                          <input
                            value={this.state.countryCode}
                            disabled
                            style={{ height: 40, margin: 0 }}
                          />
                        </div>
                      </>
                    </FormGroup>
                    <Button
                      class="btn-color"
                      fill
                      onClick={() => this.handleOnSubmit()}
                      disabled={!this.state.countryCode}>
                      Submit
                    </Button>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default AddCountry;
